export class Header {
    value: any;
    displayValue: any;
    sorting: boolean = false;
    order: string = 'asc';
    styles: any = {};

    constructor(value) {
        this.value = value;
        this.setDisplayValue();
    }

    setDisplayValue() {
        if (typeof this.value != 'object') {
            return this.displayValue = this.value;
        }

        this.displayValue = this.value.data;

        if (this.value.styles) {
            this.styles = this.value.styles;
        }
    }

    clearSorting() {
        this.sorting = false;
        this.order = 'asc';
    }

    get changedOrder() {
        return this.order == 'asc'? 'desc': 'asc';
    }
}
